import { atom } from "recoil";

export const tokenSnifferAddressState = atom({
  key: "tokenSnifferAddressState",
  default: "",
});

export const analysisAddressState = atom({
  key: "analysisAddressState",
  default: "",
});
